import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-imagenes',
  standalone: true,
  imports: [],
  templateUrl: '../../../movi-link/hero-pages/hero-movi-link.component.html',
  styleUrl: './hero-imagenes.component.css'
})
export class HeroImagenesComponent {

  title = 'Imágenes';
  subtitle1 = 'Resultados';
  subtitle2 = 'precisos y confiables';
  callToAction = 'Contáctanos';
  routeImageMain = 'assets/img/imagenes/bannerImagenOk.svg';

}
